export default {
    'OPERACION_PAGO': (state, mutation) => {
        state.operacion = mutation.oper
        state.pago = mutation.pago
    }
}